import { Group, Rect, Text,Arc } from 'react-konva';
import React from 'react';

class Door extends React.Component {
    render() {
        let xMin = this.props.offset * this.props.scale;
        let xMax = (this.props.offset + this.props.saunaWidth - this.props.doorWidth) * this.props.scale;
        let preventDefault = this.props.draggable;

        let onDragEnd = (e) => {
            this.props.doorFromLeftUpdated(e.currentTarget.attrs.x - this.props.offset);
        }

        let dragBound = (pos) => {
            return {
                x: Math.min(Math.max(pos.x, xMin), xMax),
                y: this.group.getAbsolutePosition().y
            };
        };
        return (

            <Group ref={(group) => { this.group = group; }} x={this.props.startx} y={this.props.starty} draggable={this.props.draggable} preventDefault={preventDefault} dragBoundFunc={dragBound} onClick={this.props.onDoorClick} onTap={this.props.onDoorClick} onDragEnd={onDragEnd.bind(this)}>
                <Rect height={80} y={-40} width={this.props.doorWidth} stroke={"black"} strokeWidth={5} fill="white" preventDefault={preventDefault}></Rect>
                <Rect height={400} y={-300} width={this.props.doorWidth} preventDefault={preventDefault}></Rect>
                {this.drawArc(this.props)}
                <Text x={this.props.doorWidth * 0.3} text={this.props.doorWidth + " mm"} y={-140} fontSize={100} fontStyle="bold" preventDefault={preventDefault}></Text>
            </Group>
        );
    }
    drawArc(props) {
        if (props.doorHandness == "left") {
            return <Arc angle={90} strokeWidth="5" stroke="black" innerRadius={props.doorWidth} preventDefault={props.draggable}></Arc>
        }
        else {
            return <Arc rotation={180} angle={-90} clockwise={true} strokeWidth="5" stroke="black" x={props.doorWidth} innerRadius={props.doorWidth} preventDefault={props.draggable}></Arc>

        }
   

    }

}
export default Door;
